import { Flex, Progress, Text } from '@chakra-ui/react';

interface Props {
  acceptedPriceCount: number;
  priceCount: number;
  isAccepted: boolean;
}

export function InquiryAcceptRate({
  acceptedPriceCount,
  priceCount,
  isAccepted,
}: Props) {
  const acceptRate =
    priceCount > 0 ? Math.round((acceptedPriceCount / priceCount) * 100) : 0;

  return (
    <Flex direction="column" gap={1} minW="120px">
      <Text fontSize="sm" fontWeight="medium">
        {acceptedPriceCount}/{priceCount} ({acceptRate}%)
      </Text>
      <Progress
        value={acceptRate}
        size="xs"
        colorScheme={isAccepted ? 'green' : 'blue'}
        borderRadius="full"
      />
    </Flex>
  );
}
